import React, { useState } from "react";
import "./Theme.css";

// import Digitalprofilphoto from "../../../assests/img1/digitalprofilphoto.png";
// import profile_interfacegalleryimg1 from "../../../assests/img1/profile_interfacegalleryimg1.png";
// import profile_interfacegalleryimg2 from "../../../assests/img1/profile_interfacegalleryimg2.png";
// import profile_interfacegalleryimg3 from "../../../assests/img1/profile_interfacegalleryimg3.png";
// import profile_interfacegalleryimg4 from "../../../assests/img1/profile_interfacegalleryimg4.png";
// import profile_interfacevideoimg1 from "../../../assests/img1/profile_interfacevideoimg1.png";
// import profile_interfacevideoimg2 from "../../../assests/img1/profile_interfacevideoimg2.png";
import { Collapse } from "antd";

function Theme() {
  const [isExpanded, setIsExpanded] = useState(false);
  const [contactExpand, setContactExpand] = useState(false);
  console.log("contactExpand",contactExpand);
  const [socialMediaExpand, setSocialMediaExpand] = useState(false);
  
  const [websiteExpand, setWebsiteExpand] = useState(false);
  const [galleryExpand, setGalleryExpand] = useState(false);
  const [videoExpand, setVideoExpand] = useState(false);
  const { Panel } = Collapse;
  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const rightArrow = (
    <svg
      width="9"
      height="15"
      viewBox="0 0 9 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.36146 6.76349C8.55674 6.95883 8.66644 7.22373 8.66644 7.49994C8.66644 7.77616 8.55674 8.04106 8.36146 8.2364L2.46875 14.1291C2.37266 14.2286 2.25772 14.308 2.13063 14.3626C2.00354 14.4171 1.86686 14.4459 1.72854 14.4471C1.59023 14.4483 1.45307 14.4219 1.32505 14.3696C1.19703 14.3172 1.08073 14.2398 0.982923 14.142C0.885118 14.0442 0.807771 13.9279 0.755395 13.7999C0.703019 13.6719 0.676663 13.5347 0.677865 13.3964C0.679067 13.2581 0.707803 13.1214 0.762396 12.9943C0.816988 12.8672 0.896344 12.7523 0.995834 12.6562L6.15208 7.49994L0.995834 2.34369C0.806086 2.14723 0.701092 1.88411 0.703465 1.61098C0.705839 1.33786 0.81539 1.0766 1.00852 0.883466C1.20166 0.690333 1.46292 0.580782 1.73604 0.578409C2.00916 0.576035 2.27229 0.681029 2.46875 0.870777L8.36146 6.76349Z"
        fill="white"
      />
    </svg>
  );
  const downArrow = (
    <svg
      width="15"
      height="18"
      viewBox="0 0 15 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.23645 8.36143C8.04111 8.55671 7.77621 8.66641 7.49999 8.66641C7.22378 8.66641 6.95888 8.55671 6.76354 8.36143L0.870828 2.46872C0.771337 2.37263 0.69198 2.25769 0.637387 2.1306C0.582795 2.00351 0.55406 1.86682 0.552858 1.72851C0.551657 1.5902 0.578012 1.45304 0.630388 1.32502C0.682764 1.197 0.760112 1.0807 0.857917 0.982892C0.955722 0.885087 1.07202 0.80774 1.20004 0.755364C1.32806 0.702988 1.46523 0.676632 1.60354 0.677834C1.74185 0.679036 1.87854 0.707772 2.00562 0.762365C2.13271 0.816957 2.24765 0.896313 2.34374 0.995803L7.49999 6.15205L12.6562 0.995804C12.8527 0.806056 13.1158 0.701062 13.389 0.703435C13.6621 0.705808 13.9233 0.815359 14.1165 1.00849C14.3096 1.20163 14.4192 1.46289 14.4215 1.73601C14.4239 2.00913 14.3189 2.27226 14.1292 2.46872L8.23645 8.36143Z"
        fill="white"
      />
    </svg>
  );

  const phone = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.62 10.79C8.06 13.62 10.38 15.93 13.21 17.38L15.41 15.18C15.68 14.91 16.08 14.82 16.43 14.94C17.55 15.31 18.76 15.51 20 15.51C20.55 15.51 21 15.96 21 16.51V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79Z"
        fill="white"
      />
    </svg>
  );

  const headling = (
    <span className="flex">
      {phone}
      <p className="text-white ml-2">Contact Info</p>
    </span>
  );

  return (
    <>
      <div className="digitalcontainer">
        <div className="digitalcontainer_center relative">
          <div className="digitalcontainer_banner">
            <div className="flex justify-center items-center">
              <svg
                width="167"
                height="45"
                viewBox="0 0 167 45"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.88574 37.1564H23.0662V44H0.254144V0.965329H8.88574V37.1564ZM48.5285 44.4316C44.5004 44.4316 40.8011 43.4862 37.4307 41.5955C34.0603 39.7048 31.3886 37.0947 29.4156 33.7654C27.4427 30.395 26.4562 26.5929 26.4562 22.3594C26.4562 18.1669 27.4427 14.406 29.4156 11.0766C31.3886 7.70619 34.0603 5.07561 37.4307 3.18488C40.8011 1.29415 44.5004 0.348787 48.5285 0.348787C52.5976 0.348787 56.2969 1.29415 59.6262 3.18488C62.9967 5.07561 65.6478 7.70619 67.5796 11.0766C69.5526 14.406 70.539 18.1669 70.539 22.3594C70.539 26.5929 69.5526 30.395 67.5796 33.7654C65.6478 37.0947 62.9967 39.7048 59.6262 41.5955C56.2558 43.4862 52.5565 44.4316 48.5285 44.4316ZM48.5285 36.7248C51.1179 36.7248 53.3991 36.1494 55.3721 34.9985C57.345 33.8065 58.8864 32.1213 59.9962 29.9428C61.1059 27.7644 61.6608 25.2366 61.6608 22.3594C61.6608 19.4822 61.1059 16.9749 59.9962 14.8375C58.8864 12.6591 57.345 10.9944 55.3721 9.84354C53.3991 8.69266 51.1179 8.11722 48.5285 8.11722C45.939 8.11722 43.6372 8.69266 41.6232 9.84354C39.6503 10.9944 38.1089 12.6591 36.9991 14.8375C35.8893 16.9749 35.3345 19.4822 35.3345 22.3594C35.3345 25.2366 35.8893 27.7644 36.9991 29.9428C38.1089 32.1213 39.6503 33.8065 41.6232 34.9985C43.6372 36.1494 45.939 36.7248 48.5285 36.7248ZM106.925 13.9127C105.938 12.1042 104.582 10.7273 102.855 9.78189C101.129 8.83652 99.1151 8.36384 96.8134 8.36384C94.265 8.36384 92.0043 8.93928 90.0314 10.0902C88.0585 11.241 86.5171 12.8852 85.4073 15.0225C84.2976 17.1598 83.7427 19.626 83.7427 22.421C83.7427 25.2982 84.2976 27.8055 85.4073 29.9428C86.5582 32.0802 88.1407 33.7243 90.1547 34.8752C92.1688 36.026 94.5116 36.6015 97.1833 36.6015C100.472 36.6015 103.164 35.7383 105.26 34.012C107.356 32.2446 108.733 29.799 109.391 26.6752H94.5938V20.0781H117.899V27.6C117.324 30.6005 116.091 33.3749 114.2 35.9233C112.309 38.4717 109.864 40.5268 106.863 42.0887C103.904 43.6095 100.574 44.3699 96.875 44.3699C92.7236 44.3699 88.9627 43.4451 85.5923 41.5955C82.263 39.7048 79.6324 37.0947 77.7006 33.7654C75.8098 30.4361 74.8645 26.6546 74.8645 22.421C74.8645 18.1874 75.8098 14.406 77.7006 11.0766C79.6324 7.70619 82.263 5.09616 85.5923 3.24654C88.9627 1.35581 92.7031 0.410441 96.8134 0.410441C101.664 0.410441 105.877 1.60242 109.452 3.98639C113.028 6.32925 115.495 9.63803 116.851 13.9127H106.925ZM144.261 44.4316C140.233 44.4316 136.534 43.4862 133.163 41.5955C129.793 39.7048 127.121 37.0947 125.148 33.7654C123.175 30.395 122.189 26.5929 122.189 22.3594C122.189 18.1669 123.175 14.406 125.148 11.0766C127.121 7.70619 129.793 5.07561 133.163 3.18488C136.534 1.29415 140.233 0.348787 144.261 0.348787C148.33 0.348787 152.03 1.29415 155.359 3.18488C158.729 5.07561 161.38 7.70619 163.312 11.0766C165.285 14.406 166.272 18.1669 166.272 22.3594C166.272 26.5929 165.285 30.395 163.312 33.7654C161.38 37.0947 158.729 39.7048 155.359 41.5955C151.988 43.4862 148.289 44.4316 144.261 44.4316ZM144.261 36.7248C146.851 36.7248 149.132 36.1494 151.105 34.9985C153.078 33.8065 154.619 32.1213 155.729 29.9428C156.839 27.7644 157.393 25.2366 157.393 22.3594C157.393 19.4822 156.839 16.9749 155.729 14.8375C154.619 12.6591 153.078 10.9944 151.105 9.84354C149.132 8.69266 146.851 8.11722 144.261 8.11722C141.672 8.11722 139.37 8.69266 137.356 9.84354C135.383 10.9944 133.842 12.6591 132.732 14.8375C131.622 16.9749 131.067 19.4822 131.067 22.3594C131.067 25.2366 131.622 27.7644 132.732 29.9428C133.842 32.1213 135.383 33.8065 137.356 34.9985C139.37 36.1494 141.672 36.7248 144.261 36.7248Z"
                  fill="black"
                />
              </svg>
            </div>
          </div>
          <div className="digitaldetails mt-[100px] ml-[20px]">
            <div className="profilecard absolute justify-between">
              <div>
                {/* <img src={Digitalprofilphoto} alt="profileimage"></img> */}
              </div>
              <div className="grid  content-center">
                <p className="text-white font-bold text-[24px]">Sushmitha</p>
                <p className="text-white font-medium text-[12px]">
                  Digital Marketing
                </p>
              </div>
            </div>
            {/* <Collapse
              defaultActiveKey={["0"]}
              bordered={false}
              expandIconPosition="end"
              style={{ color: "white", width: "350px" }}
            >
              <Panel
                header={headling}
                key="1"
                className="bg-[#2D2D2D] text-white"
              >
                <div className="text-white">
                  <div className="flex gap-3 mt-5 ">
                    <div>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.62 10.79C8.06 13.62 10.38 15.93 13.21 17.38L15.41 15.18C15.68 14.91 16.08 14.82 16.43 14.94C17.55 15.31 18.76 15.51 20 15.51C20.55 15.51 21 15.96 21 16.51V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div>
                      <p>call</p>
                      <p>+971 987654313</p>
                    </div>
                  </div>
                  <div className="flex gap-3 mt-5 ">
                    <div>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div>
                      <p>Email</p>
                      <p>name@sample.com</p>
                    </div>
                  </div>
                  <div className=" flex gap-3 mt-5 ">
                    <div>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 11.5C11.337 11.5 10.7011 11.2366 10.2322 10.7678C9.76339 10.2989 9.5 9.66304 9.5 9C9.5 8.33696 9.76339 7.70107 10.2322 7.23223C10.7011 6.76339 11.337 6.5 12 6.5C12.663 6.5 13.2989 6.76339 13.7678 7.23223C14.2366 7.70107 14.5 8.33696 14.5 9C14.5 9.3283 14.4353 9.65339 14.3097 9.95671C14.1841 10.26 13.9999 10.5356 13.7678 10.7678C13.5356 10.9999 13.26 11.1841 12.9567 11.3097C12.6534 11.4353 12.3283 11.5 12 11.5ZM12 2C10.1435 2 8.36301 2.7375 7.05025 4.05025C5.7375 5.36301 5 7.14348 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 7.14348 18.2625 5.36301 16.9497 4.05025C15.637 2.7375 13.8565 2 12 2Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div>
                      <p>Location</p>
                      <p>
                        name@The AB Tower Building Business Bay, L.A - USA..com
                      </p>
                    </div>
                  </div>
                  <div className="flex justify-center gap-5">
                    <button className="bg-white w-[52px] h-[40px] p-[10px] rounded-[23px]">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.2463 3.36842C18.6355 2.35759 17.6421 1.36426 16.6313 1.75342L2.46798 7.20009C1.33465 7.63509 1.42465 9.26676 2.59798 9.57509L8.44048 11.1126C8.54764 11.1407 8.6454 11.1968 8.72374 11.2752C8.80208 11.3535 8.85819 11.4513 8.88631 11.5584L10.4238 17.4001C10.7321 18.5743 12.3638 18.6634 12.7988 17.5309L18.2463 3.36842Z"
                          fill="black"
                        />
                      </svg>
                    </button>
                    <button className="bg-white w-[150px] h-[40px] rounded-[23px]">
                      <div className="flex text-black flex justify-center  mt-3 gap-2">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M15.833 9.16683H10.833V4.16683C10.833 3.94582 10.7452 3.73385 10.5889 3.57757C10.4326 3.42129 10.2207 3.3335 9.99967 3.3335C9.77866 3.3335 9.5667 3.42129 9.41042 3.57757C9.25414 3.73385 9.16634 3.94582 9.16634 4.16683V9.16683H4.16634C3.94533 9.16683 3.73337 9.25463 3.57709 9.41091C3.42081 9.56719 3.33301 9.77915 3.33301 10.0002C3.33301 10.2212 3.42081 10.4331 3.57709 10.5894C3.73337 10.7457 3.94533 10.8335 4.16634 10.8335H9.16634V15.8335C9.16634 16.0545 9.25414 16.2665 9.41042 16.4228C9.5667 16.579 9.77866 16.6668 9.99967 16.6668C10.2207 16.6668 10.4326 16.579 10.5889 16.4228C10.7452 16.2665 10.833 16.0545 10.833 15.8335V10.8335H15.833C16.054 10.8335 16.266 10.7457 16.4223 10.5894C16.5785 10.4331 16.6663 10.2212 16.6663 10.0002C16.6663 9.77915 16.5785 9.56719 16.4223 9.41091C16.266 9.25463 16.054 9.16683 15.833 9.16683Z"
                            fill="black"
                          />
                        </svg>

                        <p>Add contact</p>
                      </div>
                    </button>
                  </div>
                </div>
              </Panel>
            </Collapse> */}
            <div>
              <div className="bg-[#2D2D2D] p-[16px] w-[350px] h-full text-white  flex rounded-[12px] justify-between">
                <details className="flex justify-between">
                  <summary className="flex  gap-[150px]">
                    <div className="gap-2 flex ">
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3 14C3 12 7 10.9 9 10.9C11 10.9 15 12 15 14V15H3M12 6C12 6.79565 11.6839 7.55871 11.1213 8.12132C10.5587 8.68393 9.79565 9 9 9C8.20435 9 7.44129 8.68393 6.87868 8.12132C6.31607 7.55871 6 6.79565 6 6C6 5.20435 6.31607 4.44129 6.87868 3.87868C7.44129 3.31607 8.20435 3 9 3C9.79565 3 10.5587 3.31607 11.1213 3.87868C11.6839 4.44129 12 5.20435 12 6ZM0 2V16C0 16.5304 0.210714 17.0391 0.585786 17.4142C0.960859 17.7893 1.46957 18 2 18H16C16.5304 18 17.0391 17.7893 17.4142 17.4142C17.7893 17.0391 18 16.5304 18 16V2C18 1.46957 17.7893 0.960859 17.4142 0.585786C17.0391 0.210714 16.5304 0 16 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2Z"
                          fill="white"
                        />
                      </svg>
                      CONTACT info
                    </div>

                    <div
                      onClick={() => {
                        setContactExpand(!contactExpand);
                      }}
                    >
                      {contactExpand ? downArrow : rightArrow}
                    </div>
                  </summary>
                  {contactExpand && (
                    <div>
                      <div className="flex gap-3 mt-5 ">
                        <div>
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.62 10.79C8.06 13.62 10.38 15.93 13.21 17.38L15.41 15.18C15.68 14.91 16.08 14.82 16.43 14.94C17.55 15.31 18.76 15.51 20 15.51C20.55 15.51 21 15.96 21 16.51V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                        <div>
                          <p>call</p>
                          <p>+971 987654313</p>
                        </div>
                      </div>
                      <div className="flex gap-3 mt-5 ">
                        <div>
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                        <div>
                          <p>Email</p>
                          <p>name@sample.com</p>
                        </div>
                      </div>
                      <div className=" flex gap-3 mt-5 ">
                        <div>
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12 11.5C11.337 11.5 10.7011 11.2366 10.2322 10.7678C9.76339 10.2989 9.5 9.66304 9.5 9C9.5 8.33696 9.76339 7.70107 10.2322 7.23223C10.7011 6.76339 11.337 6.5 12 6.5C12.663 6.5 13.2989 6.76339 13.7678 7.23223C14.2366 7.70107 14.5 8.33696 14.5 9C14.5 9.3283 14.4353 9.65339 14.3097 9.95671C14.1841 10.26 13.9999 10.5356 13.7678 10.7678C13.5356 10.9999 13.26 11.1841 12.9567 11.3097C12.6534 11.4353 12.3283 11.5 12 11.5ZM12 2C10.1435 2 8.36301 2.7375 7.05025 4.05025C5.7375 5.36301 5 7.14348 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 7.14348 18.2625 5.36301 16.9497 4.05025C15.637 2.7375 13.8565 2 12 2Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                        <div>
                          <p>Location</p>
                          <p>
                            name@The AB Tower Building Business Bay, L.A -
                            USA..com
                          </p>
                        </div>
                      </div>
                      <div className="flex justify-center gap-5">
                        <button className="bg-white w-[52px] h-[40px] p-[10px] rounded-[23px]">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M18.2463 3.36842C18.6355 2.35759 17.6421 1.36426 16.6313 1.75342L2.46798 7.20009C1.33465 7.63509 1.42465 9.26676 2.59798 9.57509L8.44048 11.1126C8.54764 11.1407 8.6454 11.1968 8.72374 11.2752C8.80208 11.3535 8.85819 11.4513 8.88631 11.5584L10.4238 17.4001C10.7321 18.5743 12.3638 18.6634 12.7988 17.5309L18.2463 3.36842Z"
                              fill="black"
                            />
                          </svg>
                        </button>
                        <button className="bg-white w-[150px] h-[40px] rounded-[23px]">
                          <div className="flex text-black flex justify-center  mt-3 gap-2">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M15.833 9.16683H10.833V4.16683C10.833 3.94582 10.7452 3.73385 10.5889 3.57757C10.4326 3.42129 10.2207 3.3335 9.99967 3.3335C9.77866 3.3335 9.5667 3.42129 9.41042 3.57757C9.25414 3.73385 9.16634 3.94582 9.16634 4.16683V9.16683H4.16634C3.94533 9.16683 3.73337 9.25463 3.57709 9.41091C3.42081 9.56719 3.33301 9.77915 3.33301 10.0002C3.33301 10.2212 3.42081 10.4331 3.57709 10.5894C3.73337 10.7457 3.94533 10.8335 4.16634 10.8335H9.16634V15.8335C9.16634 16.0545 9.25414 16.2665 9.41042 16.4228C9.5667 16.579 9.77866 16.6668 9.99967 16.6668C10.2207 16.6668 10.4326 16.579 10.5889 16.4228C10.7452 16.2665 10.833 16.0545 10.833 15.8335V10.8335H15.833C16.054 10.8335 16.266 10.7457 16.4223 10.5894C16.5785 10.4331 16.6663 10.2212 16.6663 10.0002C16.6663 9.77915 16.5785 9.56719 16.4223 9.41091C16.266 9.25463 16.054 9.16683 15.833 9.16683Z"
                                fill="black"
                              />
                            </svg>

                            <p>Add contact</p>
                          </div>
                        </button>
                      </div>
                    </div>
                  )}
                </details>
              </div>
            </div>
            
            <div className="mt-5">
              <div className="bg-[#2D2D2D]  w-[350px] h-full text-white p-[16px] flex rounded-[12px] justify-between">
                <details className="flex justify-between">
                  <summary className="flex  gap-[200px]">
                    <div className="gap-2 flex ">
                      <svg
                        width="26"
                        height="24"
                        viewBox="0 0 26 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_9_43)">
                          <path
                            d="M22.7656 3.14996C22.497 2.98314 22.1898 2.88221 21.871 2.85605C21.5523 2.8299 21.2317 2.87932 20.9375 2.99996L11.2969 6.64496C11.0686 6.73414 10.8245 6.77998 10.5781 6.77996H4.40625C3.88825 6.77996 3.39146 6.97751 3.02518 7.32914C2.6589 7.68077 2.45312 8.15768 2.45312 8.65496V8.80496H0.5V13.305H2.45312V13.5C2.46536 13.9894 2.67653 14.4548 3.04149 14.7968C3.40646 15.1388 3.89627 15.3301 4.40625 15.33L6.75 20.1C6.9087 20.4212 7.15856 20.6929 7.47088 20.8839C7.78319 21.075 8.14531 21.1776 8.51562 21.18H9.5C10.0153 21.176 10.5081 20.9767 10.871 20.6255C11.2339 20.2743 11.4375 19.7997 11.4375 19.305V15.51L20.9375 19.155C21.1712 19.2442 21.4204 19.29 21.6719 19.29C22.062 19.2839 22.442 19.1693 22.7656 18.96C23.0226 18.7934 23.2346 18.5705 23.384 18.3096C23.5335 18.0488 23.6161 17.7575 23.625 17.46V4.69496C23.6236 4.38974 23.5445 4.08946 23.3948 3.82021C23.245 3.55097 23.029 3.32089 22.7656 3.14996ZM9.48437 8.65496V13.5H4.40625V8.65496H9.48437ZM9.48437 19.305H8.5L6.57812 15.33H9.48437V19.305ZM12.0156 13.725C11.8301 13.6339 11.6367 13.5587 11.4375 13.5V8.54996C11.6348 8.51089 11.8282 8.45569 12.0156 8.38496L21.6719 4.69496V17.415L12.0156 13.725ZM23.6719 9.17996V12.93C24.1899 12.93 24.6867 12.7324 25.0529 12.3808C25.4192 12.0292 25.625 11.5522 25.625 11.055C25.625 10.5577 25.4192 10.0808 25.0529 9.72914C24.6867 9.37751 24.1899 9.17996 23.6719 9.17996Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_9_43">
                            <rect
                              width="25"
                              height="24"
                              fill="white"
                              transform="translate(0.5)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      Socials
                    </div>
                    <div
                      onClick={() => {
                        setSocialMediaExpand(!socialMediaExpand);
                      }}
                    >
                      {socialMediaExpand ? downArrow : rightArrow}
                    </div>
                  </summary>
                  {socialMediaExpand && (
                    <div>
                      <div className="flex mt-5 bg-white w-[300px] p-[16px] justify-between  rounded-[8px]">
                        <div className="flex gap-3">
                          <div className="text-black">
                            <svg
                              width="48"
                              height="48"
                              viewBox="0 0 48 48"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M44 24C44 12.96 35.04 4 24 4C12.96 4 4 12.96 4 24C4 33.68 10.88 41.74 20 43.6V30H16V24H20V19C20 15.14 23.14 12 27 12H32V18H28C26.9 18 26 18.9 26 20V24H32V30H26V43.9C36.1 42.9 44 34.38 44 24Z"
                                fill="black"
                              />
                            </svg>
                          </div>
                          <div className="text-black text-[14px] h-[50px]">
                            <p className="text-[14px] font-semibold text-left">
                              call
                            </p>
                            <p className="text-[14px] font-normal text-left">
                              +971 987654313
                            </p>
                          </div>
                        </div>
                        <div>
                          <svg
                            width="9"
                            height="9"
                            viewBox="0 0 9 9"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="1.75" cy="1.75" r="1.75" fill="black" />
                            <circle cx="7.25" cy="1.75" r="1.75" fill="black" />
                            <circle
                              cx="7.25"
                              cy="7.25012"
                              r="1.75"
                              fill="black"
                            />
                          </svg>
                        </div>
                      </div>
                      <div className="flex  mt-5 bg-white p-[16px] justify-between rounded-[8px]">
                        <div className="flex gap-3">
                          <div className="text-black">
                            <svg
                              width="40"
                              height="40"
                              viewBox="0 0 40 40"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M11.6 0H28.4C34.8 0 40 5.2 40 11.6V28.4C40 31.4765 38.7779 34.427 36.6024 36.6024C34.427 38.7779 31.4765 40 28.4 40H11.6C5.2 40 0 34.8 0 28.4V11.6C0 8.52349 1.22214 5.57298 3.39756 3.39756C5.57298 1.22214 8.52349 0 11.6 0ZM11.2 4C9.29044 4 7.45909 4.75857 6.10883 6.10883C4.75857 7.45909 4 9.29044 4 11.2V28.8C4 32.78 7.22 36 11.2 36H28.8C30.7096 36 32.5409 35.2414 33.8912 33.8912C35.2414 32.5409 36 30.7096 36 28.8V11.2C36 7.22 32.78 4 28.8 4H11.2ZM30.5 7C31.163 7 31.7989 7.26339 32.2678 7.73223C32.7366 8.20107 33 8.83696 33 9.5C33 10.163 32.7366 10.7989 32.2678 11.2678C31.7989 11.7366 31.163 12 30.5 12C29.837 12 29.2011 11.7366 28.7322 11.2678C28.2634 10.7989 28 10.163 28 9.5C28 8.83696 28.2634 8.20107 28.7322 7.73223C29.2011 7.26339 29.837 7 30.5 7ZM20 10C22.6522 10 25.1957 11.0536 27.0711 12.9289C28.9464 14.8043 30 17.3478 30 20C30 22.6522 28.9464 25.1957 27.0711 27.0711C25.1957 28.9464 22.6522 30 20 30C17.3478 30 14.8043 28.9464 12.9289 27.0711C11.0536 25.1957 10 22.6522 10 20C10 17.3478 11.0536 14.8043 12.9289 12.9289C14.8043 11.0536 17.3478 10 20 10ZM20 14C18.4087 14 16.8826 14.6321 15.7574 15.7574C14.6321 16.8826 14 18.4087 14 20C14 21.5913 14.6321 23.1174 15.7574 24.2426C16.8826 25.3679 18.4087 26 20 26C21.5913 26 23.1174 25.3679 24.2426 24.2426C25.3679 23.1174 26 21.5913 26 20C26 18.4087 25.3679 16.8826 24.2426 15.7574C23.1174 14.6321 21.5913 14 20 14Z"
                                fill="black"
                              />
                            </svg>
                          </div>
                          <div className="text-black text-[14px] h-[50px]">
                            <p className="text-[14px] font-semibold text-left">
                              Instagram
                            </p>
                            <p className="text-[14px] font-normal text-left">
                              name@sample.com
                            </p>
                          </div>
                        </div>
                        <div>
                          <svg
                            width="9"
                            height="9"
                            viewBox="0 0 9 9"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="1.75" cy="1.75" r="1.75" fill="black" />
                            <circle cx="7.25" cy="1.75" r="1.75" fill="black" />
                            <circle
                              cx="7.25"
                              cy="7.25012"
                              r="1.75"
                              fill="black"
                            />
                          </svg>
                        </div>
                      </div>
                      <div className="flex  mt-5 bg-white p-[16px] justify-between rounded-[8px]">
                        <div className="flex gap-3">
                          <div className="text-black">
                            <svg
                              width="48"
                              height="48"
                              viewBox="0 0 48 48"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M36.4097 4.5H43.0257L28.5717 21.02L45.5757 43.5H32.2597L21.8317 29.866L9.89969 43.5H3.27969L18.7397 25.83L2.42969 4.5H16.0797L25.5057 16.962L36.4057 4.5H36.4097ZM34.0877 39.54H37.7537L14.0897 8.252H10.1557L34.0877 39.54Z"
                                fill="black"
                              />
                            </svg>
                          </div>
                          <div className="text-black text-[14px] h-[50px]">
                            <p className="text-[14px] font-semibold text-left">
                              Twitter
                            </p>
                            <p className="text-[14px] font-normal text-left">
                              name@sample.com
                            </p>
                          </div>
                        </div>
                        <div>
                          <svg
                            width="9"
                            height="9"
                            viewBox="0 0 9 9"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="1.75" cy="1.75" r="1.75" fill="black" />
                            <circle cx="7.25" cy="1.75" r="1.75" fill="black" />
                            <circle
                              cx="7.25"
                              cy="7.25012"
                              r="1.75"
                              fill="black"
                            />
                          </svg>
                        </div>
                      </div>
                      <div className="flex  mt-5 bg-white p-[16px] rounded-[8px] justify-between">
                        <div className="flex gap-3">
                          <div className="text-black">
                            <svg
                              width="48"
                              height="48"
                              viewBox="0 0 48 48"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M38 6C39.0609 6 40.0783 6.42143 40.8284 7.17157C41.5786 7.92172 42 8.93913 42 10V38C42 39.0609 41.5786 40.0783 40.8284 40.8284C40.0783 41.5786 39.0609 42 38 42H10C8.93913 42 7.92172 41.5786 7.17157 40.8284C6.42143 40.0783 6 39.0609 6 38V10C6 8.93913 6.42143 7.92172 7.17157 7.17157C7.92172 6.42143 8.93913 6 10 6H38ZM37 37V26.4C37 24.6708 36.3131 23.0124 35.0903 21.7897C33.8676 20.5669 32.2092 19.88 30.48 19.88C28.78 19.88 26.8 20.92 25.84 22.48V20.26H20.26V37H25.84V27.14C25.84 25.6 27.08 24.34 28.62 24.34C29.3626 24.34 30.0748 24.635 30.5999 25.1601C31.125 25.6852 31.42 26.3974 31.42 27.14V37H37ZM13.76 17.12C14.6511 17.12 15.5058 16.766 16.1359 16.1359C16.766 15.5058 17.12 14.6511 17.12 13.76C17.12 11.9 15.62 10.38 13.76 10.38C12.8636 10.38 12.0039 10.7361 11.37 11.37C10.7361 12.0039 10.38 12.8636 10.38 13.76C10.38 15.62 11.9 17.12 13.76 17.12ZM16.54 37V20.26H11V37H16.54Z"
                                fill="black"
                              />
                            </svg>
                          </div>
                          <div className="text-black text-[14px] h-[50px]">
                            <p className="text-[14px] font-semibold text-left">
                              LinkedIn
                            </p>
                            <p className="text-[14px] font-normal text-left">
                              name@sample.com
                            </p>
                          </div>
                        </div>
                        <div>
                          <svg
                            width="9"
                            height="9"
                            viewBox="0 0 9 9"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="1.75" cy="1.75" r="1.75" fill="black" />
                            <circle cx="7.25" cy="1.75" r="1.75" fill="black" />
                            <circle
                              cx="7.25"
                              cy="7.25012"
                              r="1.75"
                              fill="black"
                            />
                          </svg>
                        </div>
                      </div>
                      <div className="flex  mt-5 bg-white p-[16px] rounded-[8px] justify-between">
                        <div className="flex gap-3">
                          <div className="text-black">
                            <svg
                              width="48"
                              height="48"
                              viewBox="0 0 48 48"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M38.0996 9.82012C36.266 7.96797 34.082 6.49945 31.6749 5.50022C29.2678 4.50099 26.6858 3.99104 24.0796 4.00012C13.1596 4.00012 4.25961 12.9001 4.25961 23.8201C4.25961 27.3201 5.17961 30.7201 6.89961 33.7201L4.09961 44.0001L14.5996 41.2401C17.4996 42.8201 20.7596 43.6601 24.0796 43.6601C34.9996 43.6601 43.8996 34.7601 43.8996 23.8401C43.8996 18.5401 41.8396 13.5601 38.0996 9.82012ZM24.0796 40.3001C21.1196 40.3001 18.2196 39.5001 15.6796 38.0001L15.0796 37.6401L8.83961 39.2801L10.4996 33.2001L10.0996 32.5801C8.4551 29.9541 7.58189 26.9186 7.57961 23.8201C7.57961 14.7401 14.9796 7.34012 24.0596 7.34012C28.4596 7.34012 32.5996 9.06012 35.6996 12.1801C37.2346 13.708 38.451 15.5254 39.2784 17.527C40.1058 19.5285 40.5277 21.6743 40.5196 23.8401C40.5596 32.9201 33.1596 40.3001 24.0796 40.3001ZM33.1196 27.9801C32.6196 27.7401 30.1796 26.5401 29.7396 26.3601C29.2796 26.2001 28.9596 26.1201 28.6196 26.6001C28.2796 27.1001 27.3396 28.2201 27.0596 28.5401C26.7796 28.8801 26.4796 28.9201 25.9796 28.6601C25.4796 28.4201 23.8796 27.8801 21.9996 26.2001C20.5196 24.8801 19.5396 23.2601 19.2396 22.7601C18.9596 22.2601 19.1996 22.0001 19.4596 21.7401C19.6796 21.5201 19.9596 21.1601 20.1996 20.8801C20.4396 20.6001 20.5396 20.3801 20.6996 20.0601C20.8596 19.7201 20.7796 19.4401 20.6596 19.2001C20.5396 18.9601 19.5396 16.5201 19.1396 15.5201C18.7396 14.5601 18.3196 14.6801 18.0196 14.6601H17.0596C16.7196 14.6601 16.1996 14.7801 15.7396 15.2801C15.2996 15.7801 14.0196 16.9801 14.0196 19.4201C14.0196 21.8601 15.7996 24.2201 16.0396 24.5401C16.2796 24.8801 19.5396 29.8801 24.4996 32.0201C25.6796 32.5401 26.5996 32.8401 27.3196 33.0601C28.4996 33.4401 29.5796 33.3801 30.4396 33.2601C31.3996 33.1201 33.3796 32.0601 33.7796 30.9001C34.1996 29.7401 34.1996 28.7601 34.0596 28.5401C33.9196 28.3201 33.6196 28.2201 33.1196 27.9801Z"
                                fill="black"
                              />
                            </svg>
                          </div>
                          <div className="text-black text-[14px] h-[50px]">
                            <p className="text-[14px] font-semibold text-left">
                              whatsapp
                            </p>
                            <p className="text-[14px] font-normal text-left">
                              name@sample.com
                            </p>
                          </div>
                        </div>
                        <div>
                          <svg
                            width="9"
                            height="9"
                            viewBox="0 0 9 9"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="1.75" cy="1.75" r="1.75" fill="black" />
                            <circle cx="7.25" cy="1.75" r="1.75" fill="black" />
                            <circle
                              cx="7.25"
                              cy="7.25012"
                              r="1.75"
                              fill="black"
                            />
                          </svg>
                        </div>
                      </div>
                      <div className="flex  mt-5 bg-white p-[16px] rounded-[8px] justify-between">
                        <div className="flex gap-3">
                          <div className="text-black">
                            <svg
                              width="48"
                              height="48"
                              viewBox="0 0 48 48"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M20 30L30.38 24L20 18V30ZM43.12 14.34C43.38 15.28 43.56 16.54 43.68 18.14C43.82 19.74 43.88 21.12 43.88 22.32L44 24C44 28.38 43.68 31.6 43.12 33.66C42.62 35.46 41.46 36.62 39.66 37.12C38.72 37.38 37 37.56 34.36 37.68C31.76 37.82 29.38 37.88 27.18 37.88L24 38C15.62 38 10.4 37.68 8.34 37.12C6.54 36.62 5.38 35.46 4.88 33.66C4.62 32.72 4.44 31.46 4.32 29.86C4.18 28.26 4.12 26.88 4.12 25.68L4 24C4 19.62 4.32 16.4 4.88 14.34C5.38 12.54 6.54 11.38 8.34 10.88C9.28 10.62 11 10.44 13.64 10.32C16.24 10.18 18.62 10.12 20.82 10.12L24 10C32.38 10 37.6 10.32 39.66 10.88C41.46 11.38 42.62 12.54 43.12 14.34Z"
                                fill="black"
                              />
                            </svg>
                          </div>
                          <div className="text-black text-[14px] h-[50px]">
                            <p className="text-[14px] font-semibold text-left">
                              Youtube
                            </p>
                            <p className="text-[14px] font-normal text-left">
                              name@sample.com
                            </p>
                          </div>
                        </div>
                        <div>
                          <svg
                            width="9"
                            height="9"
                            viewBox="0 0 9 9"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="1.75" cy="1.75" r="1.75" fill="black" />
                            <circle cx="7.25" cy="1.75" r="1.75" fill="black" />
                            <circle
                              cx="7.25"
                              cy="7.25012"
                              r="1.75"
                              fill="black"
                            />
                          </svg>
                        </div>
                      </div>
                      <div className="flex mt-5 bg-white p-[16px] rounded-[8px] justify-between">
                        <div className="flex gap-3">
                          <div className="text-black">
                            <svg
                              width="48"
                              height="48"
                              viewBox="0 0 48 48"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M23.744 43.53C21.364 43.53 19.776 42.406 18.358 41.416C17.35 40.702 16.406 40.024 15.292 39.836C14.7616 39.7447 14.2242 39.7005 13.686 39.704C12.742 39.704 11.992 39.846 11.458 39.954C11.118 40.014 10.834 40.07 10.61 40.07C10.378 40.07 10.084 40.006 9.97002 39.614C9.87002 39.294 9.80802 38.99 9.74602 38.696C9.58602 37.956 9.45202 37.502 9.17402 37.456C6.19602 37.002 4.41402 36.316 4.06602 35.504C4.03802 35.416 4.00402 35.324 4.00402 35.254C3.98402 35.006 4.16402 34.8 4.41402 34.754C6.77602 34.364 8.89802 33.106 10.69 31.038C12.082 29.432 12.76 27.88 12.822 27.712C12.822 27.692 12.84 27.692 12.84 27.692C13.18 26.99 13.25 26.392 13.044 25.902C12.66 24.982 11.394 24.59 10.53 24.322C10.308 24.262 10.12 24.19 9.96002 24.136C9.22002 23.842 7.98802 23.216 8.15002 22.352C8.26602 21.728 9.09402 21.282 9.77202 21.282C9.96002 21.282 10.12 21.31 10.252 21.382C11.012 21.728 11.698 21.906 12.286 21.906C13.018 21.906 13.366 21.63 13.454 21.542C13.4354 21.1464 13.4121 20.751 13.384 20.356C13.204 17.626 13 14.238 13.864 12.296C16.46 6.482 21.97 6.016 23.602 6.016L24.314 6H24.414C26.044 6 31.554 6.454 34.15 12.278C35.024 14.22 34.81 17.618 34.63 20.338L34.612 20.472C34.596 20.836 34.568 21.184 34.552 21.542C34.64 21.612 34.96 21.88 35.62 21.888C36.192 21.872 36.816 21.684 37.528 21.362C37.7251 21.2768 37.9373 21.2319 38.152 21.23C38.402 21.23 38.652 21.29 38.866 21.362H38.884C39.482 21.586 39.874 22.004 39.874 22.442C39.892 22.852 39.57 23.476 38.046 24.092C37.886 24.152 37.698 24.226 37.476 24.278C36.628 24.538 35.362 24.948 34.96 25.858C34.738 26.338 34.826 26.954 35.166 27.65C35.166 27.666 35.184 27.666 35.184 27.666C35.282 27.916 37.858 33.766 43.592 34.72C43.7092 34.7398 43.8153 34.8013 43.8907 34.8932C43.9661 34.9851 44.0056 35.1012 44.002 35.22C44.0034 35.3098 43.9821 35.3986 43.94 35.478C43.592 36.298 41.826 36.966 38.83 37.43C38.554 37.474 38.42 37.93 38.26 38.67C38.1965 38.9784 38.1225 39.2846 38.038 39.588C37.948 39.882 37.76 40.042 37.438 40.042H37.396C37.1109 40.0364 36.8269 40.0036 36.548 39.944C35.815 39.7878 35.0675 39.71 34.318 39.712C33.7806 39.7132 33.2442 39.758 32.714 39.846C31.608 40.026 30.654 40.712 29.646 41.426C28.21 42.406 26.614 43.53 24.252 43.53H23.744Z"
                                fill="black"
                              />
                            </svg>
                          </div>
                          <div className="text-black text-[14px] h-[50px]">
                            <p className="text-[14px] font-semibold text-left">
                              Snapchat
                            </p>
                            <p className="text-[14px] font-normal text-left">
                              name@sample.com
                            </p>
                          </div>
                        </div>
                        <div>
                          <svg
                            width="9"
                            height="9"
                            viewBox="0 0 9 9"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="1.75" cy="1.75" r="1.75" fill="black" />
                            <circle cx="7.25" cy="1.75" r="1.75" fill="black" />
                            <circle
                              cx="7.25"
                              cy="7.25012"
                              r="1.75"
                              fill="black"
                            />
                          </svg>
                        </div>
                      </div>
                      <div className="flex  mt-5 bg-white p-[16px] rounded-[8px] justify-between">
                        <div className="flex gap-3">
                          <div className="text-black">
                            <svg
                              width="48"
                              height="48"
                              viewBox="0 0 48 48"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M36 12C40.14 16.08 41.7 21.78 40.72 27.1C41.54 28.54 42 30.22 42 32C42 34.6522 40.9464 37.1957 39.0711 39.0711C37.1957 40.9464 34.6522 42 32 42C30.22 42 28.54 41.54 27.1 40.72C21.78 41.7 16.08 40.14 12 36C7.86 31.92 6.3 26.22 7.28 20.9C6.46 19.46 6 17.78 6 16C6 13.3478 7.05357 10.8043 8.92893 8.92893C10.8043 7.05357 13.3478 6 16 6C17.78 6 19.46 6.46 20.9 7.28C26.22 6.3 31.92 7.86 36 12ZM24.08 34.32C29.82 34.32 32.68 31.56 32.68 27.84C32.68 25.46 31.56 22.92 27.22 21.94L23.24 21.06C21.72 20.72 20 20.26 20 18.84C20 17.4 21.2 16.4 23.4 16.4C27.86 16.4 27.44 19.46 29.66 19.46C30.82 19.46 31.82 18.78 31.82 17.6C31.82 14.86 27.44 12.8 23.72 12.8C19.7 12.8 15.4 14.52 15.4 19.08C15.4 21.28 16.18 23.62 20.5 24.7L25.88 26.06C27.5 26.46 27.9 27.36 27.9 28.2C27.9 29.56 26.54 30.9 24.08 30.9C19.26 30.9 19.92 27.2 17.34 27.2C16.18 27.2 15.34 28 15.34 29.14C15.34 31.36 18 34.32 24.08 34.32Z"
                                fill="black"
                              />
                            </svg>
                          </div>
                          <div className="text-black text-[14px] h-[50px]">
                            <p className="text-[14px] font-semibold text-left">
                              Skype
                            </p>
                            <p className="text-[14px] font-normal text-left">
                              name@sample.com
                            </p>
                          </div>
                        </div>
                        <div>
                          <svg
                            width="9"
                            height="9"
                            viewBox="0 0 9 9"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="1.75" cy="1.75" r="1.75" fill="black" />
                            <circle cx="7.25" cy="1.75" r="1.75" fill="black" />
                            <circle
                              cx="7.25"
                              cy="7.25012"
                              r="1.75"
                              fill="black"
                            />
                          </svg>
                        </div>
                      </div>
                      <div className="flex  mt-5 bg-white p-[16px] rounded-[8px] justify-between">
                        <div className="flex gap-3">
                          <div className="text-black">
                            <svg
                              width="46"
                              height="46"
                              viewBox="0 0 46 46"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13.0669 33.6914C11.4174 33.6375 9.76423 33.7201 8.13266 33.9501C6.7311 34.1478 5.34751 34.4604 3.99985 34.8809C3.67282 34.9815 3.30626 35.0642 2.9972 35.2187C2.79954 35.3193 2.63782 35.4343 2.46173 35.2151C2.21735 34.9204 2.37907 34.385 2.4186 34.0471C2.49766 33.3679 2.58751 32.6923 2.69173 32.0167C3.14454 29.0087 3.75188 26.0295 4.16516 23.0143C4.34485 21.6811 4.4922 20.337 4.6647 19.0037C4.75095 18.3173 4.84798 17.6309 4.95938 16.9481C5.09595 16.1107 5.1247 15.5214 5.90813 15.0146C7.24141 14.1521 8.84063 13.7712 10.368 13.4011C12.0139 13.0021 13.6563 12.6643 15.3597 12.729C16.5528 12.7757 17.7136 13.092 18.7666 13.649C19.2769 13.9186 19.7656 14.2348 20.2292 14.5834C20.6892 14.9248 21.2499 15.2914 21.6164 15.7298C21.9434 16.1179 22.0477 16.4701 22.08 16.8726C21.8536 22.0225 21.8895 34.7911 21.9291 35.6967C21.9327 35.7721 21.9399 35.8476 21.9434 35.9231C21.9255 36.0201 21.8716 36.0956 21.7134 36.0956C21.523 36.0992 21.3145 35.9734 21.1492 35.8871C20.8078 35.7075 20.4628 35.535 20.1178 35.3732C17.8861 34.3203 15.5358 33.7704 13.0669 33.6914ZM43.5383 35.2115C43.3586 35.4307 43.2005 35.3157 43.0028 35.2151C42.6974 35.0606 42.3308 34.9779 42.0002 34.8773C40.6525 34.4568 39.2689 34.1478 37.8674 33.9465C36.2358 33.7165 34.5791 33.6375 32.9295 33.6878C30.4642 33.7668 28.1139 34.3167 25.8786 35.3696C25.5336 35.535 25.1886 35.7075 24.8472 35.8835C24.6819 35.9698 24.4734 36.092 24.2794 36.092C24.1213 36.092 24.0674 36.0165 24.0494 35.9195C24.053 35.844 24.0638 35.7686 24.0638 35.6931C24.1033 34.7875 24.1428 22.0189 23.9128 16.869C23.9452 16.4665 24.0494 16.1143 24.3728 15.7262C24.7466 15.2878 25.3036 14.9176 25.7636 14.5798C26.2272 14.2348 26.7124 13.915 27.2263 13.6454C28.2828 13.0884 29.44 12.7721 30.6331 12.7254C32.3366 12.6571 33.9789 12.9986 35.6248 13.3975C37.1522 13.7676 38.7514 14.145 40.0883 15.0111C40.8717 15.5178 40.9005 16.1071 41.037 16.9445C41.1484 17.6273 41.2455 18.3137 41.3317 19.0001C41.5006 20.337 41.648 21.6775 41.8313 23.0107C42.2445 26.0223 42.8555 29.0051 43.3047 32.0131C43.4017 32.6887 43.4988 33.3643 43.5778 34.0436C43.6209 34.3814 43.7827 34.9168 43.5383 35.2115Z"
                                fill="white"
                              />
                              <path
                                d="M45.5688 38.3884C45.5939 37.8853 45.8239 36.4801 45.8167 36.207C45.7916 32.7067 43.5706 21.1707 43.2148 18.3604L43.1933 18.1879C43.0711 17.0846 43.0244 15.7729 42.6183 14.7307C42.2086 13.6814 40.8825 13.3148 39.9266 12.9446C35.9698 11.4353 31.5028 10.1631 27.3053 11.4928C25.6666 12.0103 24.1895 12.9339 23.0036 14.3893C21.8213 12.9339 20.3406 12.0103 18.7055 11.4928C14.508 10.1631 10.0409 11.4353 6.08422 12.9446C5.12828 13.3112 3.795 13.6778 3.38891 14.7307C2.98281 15.7729 2.93609 17.081 2.81391 18.1879L2.79234 18.3604C2.43656 21.1707 0.21922 32.7067 0.19047 36.207C0.183283 36.4837 0.416876 37.8853 0.442033 38.3884C0.47797 39.1143 0.39172 39.8439 0.427658 40.5662C0.355783 40.8178 0.42047 41.055 0.575001 41.2418C0.675626 41.4359 0.830158 41.5545 0.999064 41.6156C1.3836 42.0396 2.08078 41.7593 2.53719 41.6156C6.62688 40.2931 11.1227 40.3434 15.3417 40.904C16.0892 41.001 16.8331 41.1232 17.5734 41.267C18.3425 41.4179 19.072 41.691 19.8088 41.9534C20.4161 42.169 21.0522 42.3487 21.6919 42.4709C22.1519 42.5751 22.6011 42.6182 22.8059 42.6218C22.8778 42.6218 22.9425 42.6146 23.0108 42.611C23.0791 42.611 23.1473 42.6218 23.2156 42.6218C23.4205 42.6218 23.8697 42.5787 24.3297 42.4709C24.9694 42.3487 25.6055 42.169 26.2128 41.9534C26.9495 41.691 27.6827 41.4179 28.4517 41.267C29.192 41.1232 29.9359 41.001 30.6834 40.904C34.8989 40.3434 39.3983 40.2931 43.488 41.6156C43.9408 41.7629 44.638 42.0396 45.0225 41.6156C45.195 41.5545 45.3459 41.4359 45.4466 41.2418C45.6011 41.055 45.6658 40.8178 45.5939 40.5662C45.6191 39.8403 45.5328 39.1143 45.5688 38.3884ZM13.0669 33.6914C11.4173 33.6375 9.76422 33.7201 8.13266 33.9501C6.73109 34.1478 5.3475 34.4604 3.99985 34.8809C3.67281 34.9815 3.30625 35.0642 2.99719 35.2187C2.79953 35.3193 2.63781 35.4343 2.46172 35.2151C2.21734 34.9204 2.37906 34.385 2.4186 34.0471C2.49766 33.3679 2.5875 32.6923 2.69172 32.0167C3.14453 29.0087 3.75188 26.0295 4.16516 23.0143C4.34485 21.681 4.49219 20.337 4.66469 19.0037C4.75094 18.3173 4.84797 17.6309 4.95938 16.9481C5.09594 16.1107 5.12469 15.5214 5.90813 15.0146C7.24141 14.1521 8.84063 13.7712 10.368 13.401C12.0139 13.0021 13.6563 12.6643 15.3597 12.729C16.5528 12.7757 17.7136 13.092 18.7666 13.649C19.2769 13.9185 19.7656 14.2348 20.2292 14.5834C20.6892 14.9248 21.2498 15.2914 21.6164 15.7298C21.9434 16.1179 22.0477 16.4701 22.08 16.8726C21.8536 22.0225 21.8895 34.791 21.9291 35.6967C21.9327 35.7721 21.9398 35.8476 21.9434 35.9231C21.9255 36.0201 21.8716 36.0956 21.7134 36.0956C21.523 36.0992 21.3145 35.9734 21.1492 35.8871C20.8078 35.7075 20.4628 35.535 20.1178 35.3732C17.8861 34.3203 15.5358 33.7704 13.0669 33.6914ZM43.5383 35.2115C43.3586 35.4307 43.2005 35.3157 43.0028 35.2151C42.6973 35.0606 42.3308 34.9779 42.0002 34.8773C40.6525 34.4568 39.2689 34.1478 37.8673 33.9465C36.2358 33.7165 34.5791 33.6375 32.9295 33.6878C30.4642 33.7668 28.1139 34.3167 25.8786 35.3696C25.5336 35.535 25.1886 35.7075 24.8472 35.8835C24.6819 35.9698 24.4734 36.092 24.2794 36.092C24.1213 36.092 24.0673 36.0165 24.0494 35.9195C24.053 35.844 24.0638 35.7685 24.0638 35.6931C24.1033 34.7875 24.1428 22.0189 23.9128 16.869C23.9452 16.4665 24.0494 16.1143 24.3728 15.7262C24.7466 15.2878 25.3036 14.9176 25.7636 14.5798C26.2272 14.2348 26.7123 13.915 27.2263 13.6454C28.2828 13.0884 29.44 12.7721 30.6331 12.7254C32.3366 12.6571 33.9789 12.9985 35.6248 13.3975C37.1522 13.7676 38.7514 14.145 40.0883 15.011C40.8717 15.5178 40.9005 16.1071 41.037 16.9445C41.1484 17.6273 41.2455 18.3137 41.3317 19.0001C41.5006 20.337 41.648 21.6775 41.8313 23.0107C42.2445 26.0223 42.8555 29.0051 43.3047 32.0131C43.4017 32.6887 43.4988 33.3643 43.5778 34.0435C43.6209 34.3814 43.7827 34.9168 43.5383 35.2115Z"
                                fill="#2F2F2F"
                              />
                              <path
                                d="M19.072 16.7504C15.6687 15.1547 11.0831 15.0685 7.65828 16.7072C6.75265 17.1421 7.54328 18.4538 8.44171 18.0477C11.3562 16.718 15.3525 16.9193 18.1808 18.2741C19.2014 18.7593 20.0962 17.2319 19.072 16.7504ZM18.9642 20.9551C15.3417 19.3666 10.6842 18.7665 7.02937 20.6496C6.23515 21.0593 6.93234 22.1805 7.71937 21.8283C11.0723 20.3297 15.0902 21.2102 18.3497 22.4177C19.1942 22.734 19.7944 21.318 18.9642 20.9551ZM18.7737 25.149C18.3892 24.8255 17.8537 24.6746 17.3902 24.5057C14.0264 23.2766 9.55937 23.2263 6.32859 24.8794C5.61703 25.2424 6.21718 26.2774 6.91796 26.0762C8.6789 25.5766 10.3356 25.2999 12.1648 25.2819C13.5987 25.2676 14.8997 25.4185 16.2689 25.8282C16.6822 25.9504 17.0775 25.9971 17.4728 26.184C17.7567 26.3169 18.1089 26.4858 18.4216 26.5254C19.1044 26.608 19.2445 25.6054 18.86 25.2244L18.7737 25.149ZM18.418 29.1991C14.5295 27.3663 10.1667 27.7041 6.23156 29.0913C5.41937 29.3788 5.8075 30.6294 6.63406 30.3707C8.48484 29.7885 10.0266 29.3537 11.9923 29.3285C13.8827 29.3069 15.9347 29.9251 17.6669 30.6043C18.5977 30.9744 19.3631 29.6447 18.418 29.1991ZM27.8192 18.2705C30.6475 16.9157 34.6437 16.718 37.5583 18.0441C38.4531 18.4538 39.2473 17.1385 38.3417 16.7037C34.9205 15.0649 30.3348 15.1512 26.9316 16.7468C25.9037 17.2319 26.795 18.7593 27.8192 18.2705ZM27.6539 22.4177C30.9134 21.2102 34.9312 20.3297 38.2842 21.8283C39.0712 22.1805 39.7684 21.0593 38.9742 20.6496C35.3158 18.7665 30.6583 19.3666 27.0394 20.9551C26.2092 21.318 26.8058 22.734 27.6539 22.4177ZM27.5784 26.529C27.8947 26.4894 28.2397 26.3205 28.5236 26.1876C28.9225 26.0007 29.3178 25.954 29.7311 25.8318C31.1003 25.4257 32.4012 25.2747 33.8352 25.2855C35.6644 25.2999 37.3247 25.5766 39.0856 26.0797C39.7828 26.281 40.383 25.2424 39.675 24.883C36.4442 23.2299 31.9736 23.2802 28.6134 24.5093C28.1498 24.6782 27.6144 24.8255 27.2262 25.1526L27.14 25.2316C26.7519 25.6054 26.8992 26.6116 27.5784 26.529ZM39.772 29.0913C35.8369 27.7041 31.4741 27.3663 27.5856 29.1991C26.6405 29.6447 27.4059 30.9744 28.3403 30.6043C30.0689 29.9251 32.1173 29.3069 34.0112 29.3285C35.9734 29.3537 37.5187 29.7885 39.3659 30.3707C40.1961 30.633 40.5842 29.3788 39.772 29.0913Z"
                                fill="#2F2F2F"
                              />
                            </svg>
                          </div>
                          <div className="text-black text-[14px] h-[50px]">
                            <p className="text-[14px] font-semibold text-left">
                              Company profile
                            </p>
                            <p className="text-[14px] font-normal text-left">
                              name@sample.com
                            </p>
                          </div>
                        </div>
                        <div>
                          <svg
                            width="9"
                            height="9"
                            viewBox="0 0 9 9"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="1.75" cy="1.75" r="1.75" fill="black" />
                            <circle cx="7.25" cy="1.75" r="1.75" fill="black" />
                            <circle
                              cx="7.25"
                              cy="7.25012"
                              r="1.75"
                              fill="black"
                            />
                          </svg>
                        </div>
                      </div>
                      <div className="flex  mt-5 bg-white p-[16px] rounded-[8px] justify-between">
                        <div className="flex gap-3">
                          <div className="text-black">
                            <svg
                              width="48"
                              height="48"
                              viewBox="0 0 48 48"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M33.2 11.64C31.8329 10.0792 31.0794 8.07486 31.08 6H24.9V30.8C24.8523 32.142 24.2857 33.4132 23.3195 34.3459C22.3533 35.2785 21.0629 35.7998 19.72 35.8C16.88 35.8 14.52 33.48 14.52 30.6C14.52 27.16 17.84 24.58 21.26 25.64V19.32C14.36 18.4 8.32001 23.76 8.32001 30.6C8.32001 37.26 13.84 42 19.7 42C25.98 42 31.08 36.9 31.08 30.6V18.02C33.586 19.8197 36.5947 20.7853 39.68 20.78V14.6C39.68 14.6 35.92 14.78 33.2 11.64Z"
                                fill="black"
                              />
                            </svg>
                          </div>
                          <div className="text-black text-[14px] h-[50px]">
                            <p className="text-[14px] font-semibold text-left">
                              Tiktok
                            </p>
                            <p className="text-[14px] font-normal text-left">
                              name@sample.com
                            </p>
                          </div>
                        </div>
                        <div>
                          <svg
                            width="9"
                            height="9"
                            viewBox="0 0 9 9"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="1.75" cy="1.75" r="1.75" fill="black" />
                            <circle cx="7.25" cy="1.75" r="1.75" fill="black" />
                            <circle
                              cx="7.25"
                              cy="7.25012"
                              r="1.75"
                              fill="black"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                  )}
                </details>
              </div>
            </div>
            <div className="mt-5">
              <div className="bg-[#2D2D2D]  w-[350px] h-full text-white p-[16px] flex rounded-[12px] justify-between">
                <details className="flex justify-between">
                  <summary className="flex  gap-[200px]">
                    <div className="gap-2 flex ">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11 17H7C5.61667 17 4.43733 16.5123 3.462 15.537C2.48667 14.5617 1.99933 13.3827 2 12C2 10.6167 2.48767 9.43733 3.463 8.462C4.43833 7.48667 5.61733 6.99933 7 7H11V9H7C6.16667 9 5.45833 9.29167 4.875 9.875C4.29167 10.4583 4 11.1667 4 12C4 12.8333 4.29167 13.5417 4.875 14.125C5.45833 14.7083 6.16667 15 7 15H11V17ZM8 13V11H16V13H8ZM13 17V15H17C17.8333 15 18.5417 14.7083 19.125 14.125C19.7083 13.5417 20 12.8333 20 12C20 11.1667 19.7083 10.4583 19.125 9.875C18.5417 9.29167 17.8333 9 17 9H13V7H17C18.3833 7 19.5627 7.48767 20.538 8.463C21.5133 9.43833 22.0007 10.6173 22 12C22 13.3833 21.5123 14.5627 20.537 15.538C19.5617 16.5133 18.3827 17.0007 17 17H13Z"
                          fill="white"
                        />
                      </svg>
                      Website
                    </div>
                    <div
                      onClick={() => {
                        setWebsiteExpand(!websiteExpand);
                      }}
                    >
                      {websiteExpand ? downArrow : rightArrow}
                    </div>
                  </summary>
                  {websiteExpand && (
                    <div>
                      <div className="flex gap-3 mt-5 bg-white w-[300px] p-[16px] rounded-[8px] justify-between">
                        <div className="flex gap-3">
                          <div className="text-black">
                            <svg
                              width="48"
                              height="48"
                              viewBox="0 0 48 48"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M24.9374 32.9297C25.1122 33.1039 25.2509 33.3109 25.3455 33.5388C25.4401 33.7667 25.4889 34.011 25.4889 34.2578C25.4889 34.5046 25.4401 34.7489 25.3455 34.9768C25.2509 35.2048 25.1122 35.4117 24.9374 35.5859L24.0093 36.5141C22.2505 38.2728 19.8652 39.2608 17.378 39.2608C14.8908 39.2608 12.5055 38.2728 10.7468 36.5141C8.98804 34.7553 8 32.37 8 29.8828C8 27.3956 8.98804 25.0103 10.7468 23.2516L14.5155 19.4844C16.2053 17.7904 18.4789 16.8066 20.8705 16.7346C23.2622 16.6625 25.5908 17.5077 27.3796 19.0969C27.5642 19.261 27.7148 19.4599 27.8226 19.6823C27.9304 19.9046 27.9933 20.146 28.0078 20.3926C28.0223 20.6393 27.9881 20.8864 27.9071 21.1198C27.8261 21.3533 27.7 21.5684 27.5358 21.7531C27.3717 21.9378 27.1727 22.0883 26.9504 22.1961C26.7281 22.3039 26.4867 22.3669 26.24 22.3814C25.9934 22.3959 25.7463 22.3617 25.5129 22.2807C25.2794 22.1997 25.0642 22.0735 24.8796 21.9094C23.8069 20.9568 22.4109 20.45 20.9769 20.4927C19.543 20.5354 18.1796 21.1243 17.1655 22.1391L13.3999 25.9016C12.3448 26.9566 11.7521 28.3876 11.7521 29.8797C11.7521 31.3718 12.3448 32.8027 13.3999 33.8578C14.4549 34.9129 15.8859 35.5056 17.378 35.5056C18.8701 35.5056 20.3011 34.9129 21.3561 33.8578L22.2843 32.9297C22.4584 32.7554 22.6652 32.6171 22.8928 32.5227C23.1204 32.4283 23.3644 32.3798 23.6108 32.3798C23.8572 32.3798 24.1012 32.4283 24.3288 32.5227C24.5564 32.6171 24.7632 32.7554 24.9374 32.9297ZM36.5124 10.7422C34.7522 8.98617 32.3674 8 29.8811 8C27.3948 8 25.01 8.98617 23.2499 10.7422L22.3218 11.6703C21.9695 12.0225 21.7716 12.5003 21.7716 12.9984C21.7716 13.4966 21.9695 13.9743 22.3218 14.3266C22.674 14.6788 23.1517 14.8767 23.6499 14.8767C24.148 14.8767 24.6258 14.6788 24.978 14.3266L25.9061 13.3984C26.9612 12.3434 28.3922 11.7506 29.8843 11.7506C31.3763 11.7506 32.8073 12.3434 33.8624 13.3984C34.9174 14.4535 35.5102 15.8845 35.5102 17.3766C35.5102 18.8686 34.9174 20.2996 33.8624 21.3547L30.0952 25.1234C29.0803 26.1378 27.716 26.7259 26.2817 26.7674C24.8474 26.8089 23.4515 26.3008 22.3796 25.3469C22.1949 25.1827 21.9797 25.0565 21.7463 24.9756C21.5128 24.8946 21.2657 24.8604 21.0191 24.8749C20.7724 24.8894 20.531 24.9523 20.3087 25.0601C20.0864 25.1679 19.8875 25.3184 19.7233 25.5031C19.5592 25.6878 19.433 25.903 19.352 26.1364C19.271 26.3699 19.2368 26.6169 19.2513 26.8636C19.2658 27.1103 19.3288 27.3516 19.4366 27.574C19.5444 27.7963 19.6949 27.9952 19.8796 28.1594C21.667 29.7482 23.9941 30.5939 26.3847 30.5233C28.7752 30.4527 31.0483 29.4712 32.7389 27.7797L36.5077 24.0125C38.2658 22.2528 39.2537 19.8673 39.2546 17.3799C39.2554 14.8924 38.2692 12.5063 36.5124 10.7453V10.7422Z"
                                fill="black"
                              />
                            </svg>
                          </div>
                          <div className="text-black text-[14px] h-[50px]">
                            <p className="text-[14px] font-semibold text-left">
                              Website
                            </p>
                            <p className="text-[14px] font-normal text-left">
                              name@sample.com
                            </p>
                          </div>
                        </div>
                        <div>
                          <svg
                            width="9"
                            height="9"
                            viewBox="0 0 9 9"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="1.75" cy="1.75" r="1.75" fill="black" />
                            <circle cx="7.25" cy="1.75" r="1.75" fill="black" />
                            <circle
                              cx="7.25"
                              cy="7.25012"
                              r="1.75"
                              fill="black"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                  )}
                </details>
              </div>
            </div>
            <div className="mt-5">
              <div className="bg-[#2D2D2D]  w-[350px] h-full text-white p-[16px] flex rounded-[12px] justify-between">
                <details className="flex justify-between">
                  <summary className="flex  gap-[210px]">
                    <div className="gap-2 flex ">
                      <svg
                        width="21"
                        height="22"
                        viewBox="0 0 21 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_156_27)">
                          <path
                            d="M2.25 20.75L18.75 20.75C19.5784 20.75 20.25 20.0784 20.25 19.25L20.25 2.75C20.25 1.92157 19.5784 1.25 18.75 1.25L2.25 1.25C1.42157 1.25 0.75 1.92157 0.75 2.75L0.75 19.25C0.75 20.0784 1.42157 20.75 2.25 20.75Z"
                            stroke="white"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M0.75 16.9999H20.25M5.76 16.9999L13.575 9.67994C13.7098 9.56769 13.8796 9.50623 14.055 9.50623C14.2304 9.50623 14.4002 9.56769 14.535 9.67994L20.25 13.7749"
                            stroke="white"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M6.75 9.5C7.99264 9.5 9 8.49264 9 7.25C9 6.00736 7.99264 5 6.75 5C5.50736 5 4.5 6.00736 4.5 7.25C4.5 8.49264 5.50736 9.5 6.75 9.5Z"
                            stroke="white"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_156_27">
                            <rect
                              width="21"
                              height="21"
                              fill="white"
                              transform="translate(0 0.5)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      Gallery{" "}
                    </div>
                    
                    <div
                      onClick={() => {
                        setGalleryExpand(!galleryExpand);
                      }}
                    >
                      {galleryExpand ? downArrow : rightArrow}
                    </div>
                  </summary>
                  {galleryExpand && (
                    <div>
                      <div className="grid grid-rows-2 grid-flow-col gap-4 mt-5 ">
                        {/* <img
                          src={profile_interfacegalleryimg1}
                          alt="profile_interfacegalleryimg"
                        ></img>
                        <img
                          src={profile_interfacegalleryimg2}
                          alt="profile_interfacegalleryimg"
                        ></img>
                        <img
                          src={profile_interfacegalleryimg3}
                          alt="profile_interfacegalleryimg"
                        ></img>
                        <img
                          src={profile_interfacegalleryimg4}
                          alt="profile_interfacegalleryimg"
                        ></img> */}
                      </div>
                    </div>
                  )}
                </details>
              </div>
            </div>

            <div className="mt-5">
              <div className="bg-[#2D2D2D]  w-[350px] h-full text-white p-[16px] flex rounded-[12px] justify-between">
                <details className="flex justify-between">
                  <summary className="flex  gap-[200px]">
                    <div className="gap-2 flex ">
                      <svg
                        width="27"
                        height="28"
                        viewBox="0 0 27 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19.125 12.3125V8.375C19.125 8.07663 19.0065 7.79048 18.7955 7.57951C18.5845 7.36853 18.2984 7.25 18 7.25H4.5C4.20163 7.25 3.91548 7.36853 3.7045 7.57951C3.49353 7.79048 3.375 8.07663 3.375 8.375V19.625C3.375 19.9234 3.49353 20.2095 3.7045 20.4205C3.91548 20.6315 4.20163 20.75 4.5 20.75H18C18.2984 20.75 18.5845 20.6315 18.7955 20.4205C19.0065 20.2095 19.125 19.9234 19.125 19.625V15.6875L23.625 20.1875V7.8125L19.125 12.3125Z"
                          fill="white"
                        />
                      </svg>
                      Videos{" "}
                    </div>
                    <div
                      onClick={() => {
                        setVideoExpand(!videoExpand);
                      }}
                    >
                      {videoExpand ? downArrow : rightArrow}
                    </div>
                  </summary>
                  {/* {videoExpand && (
                    <div>
                      <div className="grid  gap-4 mt-5 ">
                        <img
                          src={profile_interfacevideoimg1}
                          alt="profile_interfacevideoimg"
                        ></img>
                        <img
                          src={profile_interfacevideoimg2}
                          alt="profile_interfacevideoimg"
                        ></img>
                      </div>
                    </div>
                  )} */}
                </details>
              </div>
            </div>
            <div className="flex justify-center gap-[20px] fixed top-[90%] lg:left-[45%] left-[35%]   ">
              <button className="w-[50px] h-[50px] p-[15px] rounded-[12px]  bg-white">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.2913 7.95854H10.0413V1.70854C10.0413 1.43227 9.93151 1.16732 9.73616 0.971967C9.54081 0.776617 9.27586 0.66687 8.99959 0.66687C8.72333 0.66687 8.45837 0.776617 8.26302 0.971967C8.06767 1.16732 7.95793 1.43227 7.95793 1.70854V7.95854H1.70793C1.43166 7.95854 1.16671 8.06828 0.971357 8.26363C0.776007 8.45898 0.66626 8.72394 0.66626 9.0002C0.66626 9.27647 0.776007 9.54142 0.971357 9.73677C1.16671 9.93212 1.43166 10.0419 1.70793 10.0419H7.95793V16.2919C7.95793 16.5681 8.06767 16.8331 8.26302 17.0284C8.45837 17.2238 8.72333 17.3335 8.99959 17.3335C9.27586 17.3335 9.54081 17.2238 9.73616 17.0284C9.93151 16.8331 10.0413 16.5681 10.0413 16.2919V10.0419H16.2913C16.5675 10.0419 16.8325 9.93212 17.0278 9.73677C17.2232 9.54142 17.3329 9.27647 17.3329 9.0002C17.3329 8.72394 17.2232 8.45898 17.0278 8.26363C16.8325 8.06828 16.5675 7.95854 16.2913 7.95854Z"
                    fill="black"
                  />
                </svg>
              </button>
              <button className="w-[50px] h-[50px] p-[10px] rounded-[12px] bg-white">
                <svg
                  width="34"
                  height="34"
                  viewBox="0 0 34 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.25 9.20833C4.25 7.8933 4.77239 6.63213 5.70226 5.70226C6.63213 4.77239 7.8933 4.25 9.20833 4.25H11.849C12.2247 4.25 12.5851 4.39926 12.8507 4.66493C13.1164 4.93061 13.2657 5.29094 13.2657 5.66667C13.2657 6.04239 13.1164 6.40272 12.8507 6.6684C12.5851 6.93408 12.2247 7.08333 11.849 7.08333H9.20833C8.64475 7.08333 8.10425 7.30722 7.70573 7.70573C7.30722 8.10425 7.08333 8.64475 7.08333 9.20833V11.849C7.08333 12.2247 6.93408 12.5851 6.6684 12.8507C6.40272 13.1164 6.04239 13.2657 5.66667 13.2657C5.29094 13.2657 4.93061 13.1164 4.66493 12.8507C4.39926 12.5851 4.25 12.2247 4.25 11.849V9.20833ZM20.7343 5.66667C20.7343 5.29094 20.8836 4.93061 21.1493 4.66493C21.4149 4.39926 21.7753 4.25 22.151 4.25H24.7917C26.1067 4.25 27.3679 4.77239 28.2977 5.70226C29.2276 6.63213 29.75 7.8933 29.75 9.20833V11.849C29.75 12.2247 29.6007 12.5851 29.3351 12.8507C29.0694 13.1164 28.7091 13.2657 28.3333 13.2657C27.9576 13.2657 27.5973 13.1164 27.3316 12.8507C27.0659 12.5851 26.9167 12.2247 26.9167 11.849V9.20833C26.9167 8.64475 26.6928 8.10425 26.2943 7.70573C25.8958 7.30722 25.3553 7.08333 24.7917 7.08333H22.151C21.7753 7.08333 21.4149 6.93408 21.1493 6.6684C20.8836 6.40272 20.7343 6.04239 20.7343 5.66667ZM5.66667 20.7343C6.04239 20.7343 6.40272 20.8836 6.6684 21.1493C6.93408 21.4149 7.08333 21.7753 7.08333 22.151V24.7917C7.08333 25.3553 7.30722 25.8958 7.70573 26.2943C8.10425 26.6928 8.64475 26.9167 9.20833 26.9167H11.849C12.2247 26.9167 12.5851 27.0659 12.8507 27.3316C13.1164 27.5973 13.2657 27.9576 13.2657 28.3333C13.2657 28.7091 13.1164 29.0694 12.8507 29.3351C12.5851 29.6007 12.2247 29.75 11.849 29.75H9.20833C7.8933 29.75 6.63213 29.2276 5.70226 28.2977C4.77239 27.3679 4.25 26.1067 4.25 24.7917V22.151C4.25 21.7753 4.39926 21.4149 4.66493 21.1493C4.93061 20.8836 5.29094 20.7343 5.66667 20.7343ZM28.3333 20.7343C28.7091 20.7343 29.0694 20.8836 29.3351 21.1493C29.6007 21.4149 29.75 21.7753 29.75 22.151V24.7917C29.75 26.1067 29.2276 27.3679 28.2977 28.2977C27.3679 29.2276 26.1067 29.75 24.7917 29.75H22.151C21.7753 29.75 21.4149 29.6007 21.1493 29.3351C20.8836 29.0694 20.7343 28.7091 20.7343 28.3333C20.7343 27.9576 20.8836 27.5973 21.1493 27.3316C21.4149 27.0659 21.7753 26.9167 22.151 26.9167H24.7917C25.3553 26.9167 25.8958 26.6928 26.2943 26.2943C26.6928 25.8958 26.9167 25.3553 26.9167 24.7917V22.151C26.9167 21.7753 27.0659 21.4149 27.3316 21.1493C27.5973 20.8836 27.9576 20.7343 28.3333 20.7343ZM14.1667 9.91667H9.91667V14.1667H14.1667V19.8333H9.91667V24.0833H14.1667V19.8333H19.8333V24.0833H24.0833V19.8333H19.8333V14.1667H24.0833V9.91667H19.8333V14.1667H14.1667V9.91667Z"
                    fill="black"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Theme;